angular.module('ikeweb.spike.measure').controller('PhotoMeasureViewController', [
    '$scope',
    '$stateParams',
    'spikeCaptureService',
    'unitService',
    'pubSubService',
    'measureTopics',
    'userTopics',
    'measurementService',
    'measurementFormatterService',
    'promiseFactory',
    'STEPS',
    'stepService',
    'PhotoMeasureBuilder',
    'zoomServiceFactory',
    '$location',
    '$timeout',
    'localeTopics',
    'billingService',
    'notificationService',
    '$analytics',
    'photogrammetryToolKit',
    function($scope,
        $stateParams,
        $spikeCaptureService,
        unitService,
        pubSubService,
        measureTopics,
        userTopics,
        measurementService,
        measurementFormatterService,
        promiseFactory,
        STEPS,
        stepService,
        PhotoMeasureBuilder,
        zoomServiceFactory,
        $location,
        $timeout,
        localeTopics,
        billingService,
        notificationService,
        $analytics,
        photogrammetryToolKit) {

        $scope.STEPS = STEPS;
        var LAYERS = {
            ALIGNMENT: 'alignment',
            MAIN: 'main',
            CUTOUT: 'cutout',
            LINE: 'line'
        };

        var EVENT_TYPES = {
            AUTO_ACCEPTED: 'auto_accepted',
            AUTO_REJECTED: 'auto_rejected',
            MANUAL: 'manual',
            UNKNOWN: 'unknown',
            DEFAULT: 'default'
        };
        var perspectiveCorrectionState = EVENT_TYPES.UNKNOWN;
        var Measurement = photogrammetryToolKit.Measurement;

        $scope.LAYERS = LAYERS;
        var captureId = $stateParams.spikeid;

        var photoMeasure;
        var photoMeasureBuilder = PhotoMeasureBuilder
            .create()
            .withMeasurementFormatter(measurementFormatterService);

        function updateState() {
            if (perspectiveCorrectionState === EVENT_TYPES.AUTO_ACCEPTED || perspectiveCorrectionState === EVENT_TYPES.AUTO_REJECTED) {
                perspectiveCorrectionState = EVENT_TYPES.AUTO_REJECTED;
            } else {
                perspectiveCorrectionState = EVENT_TYPES.MANUAL;
            }
        }

        function trackPerspectiveCorrection(eventType, capture) {
            if (!photoMeasure.canCorrectPerspective() || stepService.getCurrentStep() !== STEPS.ALIGN) {
                //don't track event where user doesn't have the option to use perspective correction
                return;
            }
            var event = {
                category: 'perspective',
                action: eventType,
                label: capture && capture.id,
                value: 1
            };
            $analytics.eventTrack(eventType, event);
        }

        function setCapture(capture) {
            photoMeasureBuilder.withCapture(capture);
            $scope.capture = capture;
            $scope.note = capture.getNote();
            return capture;
        }

        function setCaptureImage(image) {
            $scope.photoMeasureImage = image;
        }

        function fetchImage(capture) {
            return $spikeCaptureService.getCaptureImage(capture);
        }

        if (captureId) {
            $spikeCaptureService.getCapture(captureId)
                .then(setCapture)
                .then(fetchImage)
                .then(setCaptureImage)
                .catch(function() {
                    $timeout(function() {
                        $location.path('gallery');
                    }, 1000);
                });
        }

        function isLayerActive(layerName) {
            return photoMeasure && photoMeasure.getActiveLayerKey() === layerName;
        }

        function isPanMode() {
            return !!photoMeasure && !photoMeasure.isDrawing();
        }

        function togglePanMode() {
            photoMeasure.toggleDrawing();
        }

        function setPanModeForEnteringStep(step) {
            if ((step === STEPS.ALIGN && !isPanMode()) || step === STEPS.MEASURE && isPanMode()) {
                togglePanMode();
            }
        }

        function showCorrectLayersFor(step) {

            switch (step) {
                case STEPS.ALIGN:
                    photoMeasure.showAlignment();
                    break;

                case STEPS.MEASURE:
                    photoMeasure.showMeasurement();
                    break;
            }
        }

        function getUserStepOrCaptureStep() {
            return stepService.getCurrentStep() || ($scope.capture.isAlignmentDone() ? STEPS.MEASURE : STEPS.ALIGN);
        }

        function changeStepAndShowCorrectLayer(step) {
            stepService.changeStep(step);
            showCorrectLayersFor(step);
            setPanModeForEnteringStep(step);
        }

        function saveMeasurements() {
            return $spikeCaptureService.saveMeasurementsForCapture($scope.capture, photoMeasure.serialize());
        }

        function saveNote() {
            return $spikeCaptureService.saveNoteForCapture($scope.capture, $scope.note);
        }

        function save() {
            var returnPromise = promiseFactory.promise();

            if (photoMeasure) {
                returnPromise = saveMeasurements();
            }


            return returnPromise.then(saveNote)
                .then(function() {
                    return $scope.capture.save();
                });
        }

        function saveThenChangeStep(step) {
            save()
                .then(function() {
                    return trackPerspectiveCorrection(perspectiveCorrectionState, $scope.capture);
                })
                .then(function() {
                    return changeStepAndShowCorrectLayer(step);
                });
        }

        function getMeasurements() {
            $scope.measurements = measurementService.createMeasurements(photoMeasure.getMeasurements());
        }

        function getNote(notes) {
            $scope.note = notes;
        }

        function updateLabels() {
            photoMeasure.updateAllLabels();
        }

        function photoMeasureInstantiated() {
            return photoMeasure !== undefined;
        }

        function init(photoMeasureInstance) {
            photoMeasure = photoMeasureInstance;
            changeStepAndShowCorrectLayer(getUserStepOrCaptureStep());
            getMeasurements();

            pubSubService.subscribe(measureTopics.NOTE.UPDATE, getNote);
            pubSubService.subscribe(measureTopics.PHOTO_MEASURE.UPDATE, getMeasurements);
            pubSubService.subscribe(userTopics.PREFERENCES.UPDATED, updateLabels);
            pubSubService.subscribe(localeTopics.LOCALE.CHANGED, updateLabels);

            $scope.$on('$destroy', function() {
                pubSubService.unsubscribe(measureTopics.NOTE.UPDATE, getNote);
                pubSubService.unsubscribe(measureTopics.PHOTO_MEASURE.UPDATE, getMeasurements);
                pubSubService.unsubscribe(userTopics.PREFERENCES.UPDATED, updateLabels);
                pubSubService.unsubscribe(localeTopics.LOCALE.CHANGED, updateLabels);
            });
        }

        photoMeasureBuilder.whenInstantiated()
            .then(init);

        this.getAutoAlignmentPolygon = function() {
            if (!photoMeasure.canCorrectPerspective()) {
                notificationService.info('NOTIFICATION.CAPTURE.PERSPECTIVE_CORRECT_IS_PRO_TITLE', 'NOTIFICATION.PERSPECTIVE_CORRECT_IS_PRO')();
                return;
            }
            notificationService.info('NOTIFICATION.CAPTURE.PERSPECTIVE_CORRECT_IN_PROGRESS_TITLE', 'NOTIFICATION.CAPTURE.PERSPECTIVE_CORRECT_IN_PROGRESS')();
            return $spikeCaptureService.getAutoAlignmentPolygon($scope.capture)
                .then(function(aa) {
                    perspectiveCorrectionState = EVENT_TYPES.AUTO_ACCEPTED;
                    photoMeasure.drawAlignmentFromPoints(aa.metaData.alignment);
                    $scope.capture.save();
                });
        };

        this.resetAlignment = function() {
            if (!photoMeasure.canCorrectPerspective()) {
                return;
            }
            if (perspectiveCorrectionState === EVENT_TYPES.AUTO_ACCEPTED) {
                perspectiveCorrectionState = EVENT_TYPES.AUTO_REJECTED;
            } else {
                perspectiveCorrectionState = EVENT_TYPES.DEFAULT;
            }

            photoMeasure.drawAlignmentFromPoints();
            $scope.capture.save();
        };

        this.photoMeasureInstantiated = photoMeasureInstantiated;

        this.getPhotoMeasureBuilder = function() {
            return photoMeasureBuilder;
        };

        this.drawAreaFromAlignment = function() {
            photoMeasure.drawAreaFromAlignment();
        };

        this.save = save;

        this.getActiveMeasurement = function() {
            return photoMeasure ? photoMeasure.getActiveMeasurement() : null;
        };

        this.activateMeasurement = function(uuid) {
            photoMeasure.activateMeasurement(uuid);
        };

        this.deleteActiveHandle = function() {
            photoMeasure.deleteActiveHandle();
        };

        this.deleteActiveMeasurement = function() {
            photoMeasure.deleteActiveMeasurement();
        };

        this.activate = function(layerName) {
            photoMeasure.activateLayer(layerName);
            photoMeasure.enableDrawing();
        };

        this.canLockRectangle = function() {
            return photoMeasure != null && photoMeasure.canLockRectangle();
        };

        this.isRectangleLocked = function() {
            return photoMeasure != null && photoMeasure.isRectangleLocked();
        };

        this.toggleRectangleLock = function() {
            return photoMeasure != null && photoMeasure.toggleRectangleLock();
        };

        this.canCorrectPerspective = function() {
            return photoMeasure != null && photoMeasure.canCorrectPerspective();
        };

        this.isCurrentStep = stepService.isCurrentStep;
        this.isLayerActive = isLayerActive;

        this.saveThenChangeStep = saveThenChangeStep;

        this.isPanMode = isPanMode;
        this.togglePanMode = togglePanMode;

        var exposeZoomServiceMethods = function(zoomService) {
            this.setZoom = zoomService.setZoom;
            this.getZoom = zoomService.getZoom;
            this.zoomIn = zoomService.zoomIn;
            this.zoomOut = zoomService.zoomOut;
            this.setViewPortScaleFactor = zoomService.setViewPortScaleFactor;
        }.bind(this);

        this.zoomService = zoomServiceFactory.create();
        exposeZoomServiceMethods(this.zoomService);
        Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.STARTED, updateState);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/photo.measure.view.controller.js
// module id = 571
// module chunks = 0